import type { WorkshopNavItem } from './workshopNavTypes';

export const WORKSHOP_SETUP_NAV: WorkshopNavItem[] = [
    { resource: 'variantInformation', label: 'Vehicle Variant' },
    { resource: 'jobType', label: 'Job Type' },
    { resource: 'jobsRateList', label: 'Jobs Rate List' },
    { resource: 'activityType', label: 'Activity Type' },
    { resource: 'maintenanceChart', label: 'Maintenance Chart' },
    { resource: 'vehicleProfile', label: 'Vehicle Profile' },
    { resource: 'customers', label: 'Customers' },
    { resource: 'customerSubParties', label: 'Customer Sub Parties' },
    { resource: 'employee', label: 'Employees' },
    { resource: 'workshopGlDefaults', label: 'Accounting Settings' },
];
